var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n                В наших инструкциях вы сможете ознакомиться с\n                примерами отчетов сервиса, их наполнением,\n                источниками данных и советами по интерпретации.")])], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-list-item', [_c('v-link', {
    attrs: {
      "to": '/public/instructions/KPFL.pdf',
      "target": "_blank"
    }
  }, [_vm._v("\n                    Комплексная проверка\n                    физического лица\n                ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-link', {
    attrs: {
      "to": '/public/instructions/KR.pdf',
      "target": "_blank"
    }
  }, [_vm._v("\n                    Кредитный рейтинг\n                ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-link', {
    attrs: {
      "to": '/public/instructions/KOFL.pdf',
      "target": "_blank"
    }
  }, [_vm._v("\n                    Кредитный отчет\n                ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-link', {
    attrs: {
      "to": '/public/instructions/Dossier.pdf',
      "target": "_blank"
    }
  }, [_vm._v("\n                    Досье\n                ")])], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0d6cf44","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/Instraction/Instraction.vue
// module id = 1147
// module chunks = 0